import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { RiPencilFill as Edit } from '@remixicon/react';

import { ButtonIcon } from '@spotify-internal/encore-web';

export type SectionEditButtonProps = Omit<
  ComponentPropsWithoutRef<typeof ButtonIcon>,
  'aria-label' | 'children' | 'variant'
>;

const SectionEditButton = forwardRef<HTMLButtonElement, SectionEditButtonProps>(
  ({ size = 'small', ...props }, ref) => (
    <ButtonIcon
      ref={ref}
      variant="tertiary"
      size={size}
      aria-label="Edit section"
      data-track-id="button.edit-section"
      data-track-action="open-dialog"
      {...props}
    >
      <Edit aria-hidden />
    </ButtonIcon>
  ),
);

SectionEditButton.displayName = 'Section.EditButton';

export default SectionEditButton;
